import axios from 'axios';
import Qs from 'qs';
import { isIE9 } from './tool';
import { requestUrl } from '@/config/app';

axios.defaults.withCredentials = true;

axios.defaults.crossDomain = true;

axios.defaults.baseURL = requestUrl;

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

axios.interceptors.response.use(
  function (response) {
    //判断是否有是ie9
    if (isIE9()) {
      //特殊处理response
      if (response.status == 200 && response.request) {
        if (
          response.request.responseType === 'json' &&
          response.request.responseText
        ) {
          response.data = JSON.parse(response.request.responseText);
          console.log('repsonse', response);
        }
      }
    }
    return response;
  },
  function (error) {
    if (error.response) {
      // 对响应错误做点什么
      console.log('error', error);
      return Promise.reject(error);
    }
  }
);

// axios.defaults.transformRequest = [
//   function (data, config) {
//     // 对 data 进行任意转换处理
//     if (config['Content-Type'] === 'multipart/form-data') {
//       return data;
//     }
//     return Qs.stringify(data);
//   },
// ];

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    const token = window.localStorage.getItem('token') || '';
    params.time = new Date().getTime();
    axios
      .get(url, {
        params: params,
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((resp) => {
        if (resp.data.code == 1) {
          resolve(resp.data.result);
        } else {
          reject(resp.data.message);
        }
      })
      .catch((err) => {
        // console.log(1111);
        reject(err);
      });
  });
}

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    const token = window.localStorage.getItem('token') || '';
    axios
      .post(url, data, { headers: { Authorization: `Bearer ${token}` } })
      .then((resp) => {
        if (resp.data.code == 1) {
          resolve(resp.data.result);
        } else {
          reject(resp.data.message);
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          reject(err.response.data.message);
        } else {
          reject(err);
        }
      });
  });
}

const upvideoconfig = axios.create({
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export function uploadfile(url, data) {
  return new Promise((resolve, reject) => {
    const token = window.localStorage.getItem('token') || '';
    upvideoconfig
      .post(url, data, { headers: { Authorization: `Bearer ${token}` } })
      .then((resp) => {
        if (resp.data.code == 1) {
          resolve(resp.data.result);
        } else {
          reject(resp.data.message);
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          reject(err.response.data.message);
        } else {
          reject(err);
        }
      });
  });
}
